/*
  VSB video facade (snippets/vsb-video-facade), for the overview video and the
  video testimonials. Nothing heavy happens until someone presses play:

  - on the page:  a poster and a play button; the player waits in a <template>.
  - near screen:  (vsbWhenNear) the video host is preconnected, so play starts fast.
  - on press:     the <video> or <iframe> is created from the template and started;
                  any other player on the page stops (the 'd:play' event, which
                  the audio previews and the before/after player also use).
*/

if (!customElements.get('d-facade')) {
  const HOSTS = { youtube: ['https://www.youtube-nocookie.com', 'https://i.ytimg.com'], vimeo: ['https://player.vimeo.com', 'https://i.vimeocdn.com'] };
  const warmed = new Set();

  customElements.define('d-facade', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('.d-facade__btn')?.addEventListener('click', () => this.play(), { once: true });
      document.addEventListener('d:play', (e) => { if (e.detail !== this) this.querySelector('video')?.pause(); });
      const warm = () => {
        this.dataset.ready = 'true';
        for (const h of HOSTS[this.dataset.kind] ?? []) {
          if (warmed.has(h)) continue;
          warmed.add(h);
          const l = document.createElement('link');
          l.rel = 'preconnect';
          l.href = h;
          document.head.appendChild(l);
        }
      };
      if (window.vsbWhenNear) window.vsbWhenNear(this, warm); else warm();
    }

    play() {
      const tpl = this.querySelector('template');
      if (!tpl) return;
      const node = tpl.content.cloneNode(true);
      const media = node.querySelector('video, iframe');
      this.querySelector('.d-facade__btn')?.replaceWith(node);
      tpl.remove();
      this.dataset.playing = 'true';
      document.dispatchEvent(new CustomEvent('d:play', { detail: this }));
      if (media?.tagName === 'VIDEO') {
        media.preload = 'auto';
        media.play?.().catch(() => { /* the controls are there */ });
      }
      media?.focus?.();
    }
  });
}
